import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getStatusPurchaseDetails = async () => {
    const respuesta = await PrivateInterceptor('status/PurchaseDetails', 'GET');
    return respuesta;
}

export const getStatusPurchase = async () => {
    const respuesta = await PrivateInterceptor('status/PurchaseRequest', 'GET');
    return respuesta;
}

export const getTipoSuministro = async () => {
    const respuesta = await PrivateInterceptor('PursacheRequest/TipoSuministro', 'GET');
    return respuesta;
}

export const getUltimoID = async () => {
    const respuesta = await PrivateInterceptor('PursacheRequest/ObtenerUltimoID', 'GET');
    return respuesta[0].IdPurchaseRequest;
}


// OBTIENER ENCABEZADO REQUISA
export const getEncabezadoRequisa = async (PurchaseRequest) => {
    const result = await PrivateInterceptor(`PursacheRequest/getEncabezadoRequisa`, 'POS', {PurchaseRequest})
    return result;
};

export const getRequisa = async (PurchaseRequest) => {
    const result = await PrivateInterceptor(`PursacheRequest/obtenerRequisa`, 'POST', {PurchaseRequest} )
    return result;
}

export const guardarEncabezadoRequisa = async (body) => {
    const respuesta = await PrivateInterceptor('PursacheRequest/encabezadoRequisa', 'POST', body);
    return respuesta;
}

export const getListadoRequisas = async (data) => {
    const respuesta = await PrivateInterceptor('PursacheRequest/listadoRequisasPorFecha', 'POST', data);
    return respuesta;
}

export const ListadoRequisas = async() => {
    const result = await PrivateInterceptor('PursacheRequest/listaRequisas', 'GET')
    return result;
}

export const correoRequisa = async(objeto) => {
    const result = await PrivateInterceptor('email/requisa', 'POST', objeto)
    return result;
}

export const getRequisaPR = async (IdPurchaseRequest) => {
    const result = await PrivateInterceptor(`PursacheRequest/detalleReportePR`, 'POST', {IdPurchaseRequest})
    return result;
};